var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


document.addEventListener("DOMContentLoaded", function () {
  //=================
  //Menu


  let dropMenu = document.getElementById("drop-menu");

  let subMenuActivators = document.querySelectorAll("[data-sub-menu-activator]");
  let subMenuDeactivators = document.querySelectorAll("[data-sub-menu-deactivator]");

  let header = document.querySelector(".header__wrapper-container");

  let dropBodies = document.querySelectorAll(".drop-menu__body");

  let menuBody = document.querySelector(".header__menu");


  let mobileMenuTrigger = document.querySelector('[data-mobile-menu-trigger]');
  let mobileMenu = document.querySelector('[data-mobile-menu]');

  let mobileSubActivators = document.querySelectorAll('[data-mobile-menu-submenu-activator]');
  let mobileSubMenus = document.querySelectorAll('[data-mobile-menu-submenu]');
  let mobileSubSubActivators = document.querySelectorAll('[data-mobile-menu-subsubmenu-activator]');
  let mobileSubSubMenus = document.querySelectorAll('[data-mobile-menu-subsubmenu]');

  let mobileSubBacks = document.querySelectorAll('[data-mobile-menu-submenu-back]');
  let mobileSubSubBacks = document.querySelectorAll('[data-mobile-menu-subsubmenu-back]');
  
  let swapPopularCols = document.querySelectorAll('[data-swap-popular-cols]');
  let popularCols = document.querySelectorAll('[data-popular-col]');

  if(mobileMenu && mobileMenuTrigger) {
    mobileMenuTrigger.addEventListener("click", function (e) {
      if(mobileMenuTrigger.classList.contains('active')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  mobileSubActivators.forEach((subActivator) => {
    subActivator.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      let toOpen = subActivator.dataset.mobileMenuSubmenuActivator;
      document.querySelector(`[data-mobile-menu-submenu="${toOpen}"]`).classList.add('active'); 
    });
  });
  mobileSubSubActivators.forEach((subSubActivator) => {
    subSubActivator.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      let toOpen = subSubActivator.dataset.mobileMenuSubsubmenuActivator;
      document.querySelector(`[data-mobile-menu-subsubmenu="${toOpen}"]`).classList.add('active'); 
    });
  });

  mobileSubBacks.forEach((mobileSubBack) => {
    mobileSubBack.addEventListener('click', (e) => {
      mobileSubMenus.forEach((submenu) => { submenu.classList.remove('active'); });
    });
  });
  mobileSubSubBacks.forEach((mobileSubSubBack) => {
    mobileSubSubBack.addEventListener('click', (e) => {
      mobileSubSubMenus.forEach((subsubmenu) => { subsubmenu.classList.remove('active'); });
    });
  });

  swapPopularCols.forEach((swapper) => {
    swapper.addEventListener('click', (e) => {
      popularCols.forEach((col => {
        col.classList.toggle('inactive');
      }));
    });
  });

  function openMobileMenu() {
    mobileMenuTrigger.classList.add("active");
    mobileMenu.classList.add("active");
    document.body.classList.add('overlay');
  }

  function closeMobileMenu() {
    mobileMenuTrigger.classList.remove("active");
    mobileMenu.classList.remove("active");
    mobileSubMenus.forEach((submenu) => { submenu.classList.remove('active'); });
    mobileSubSubMenus.forEach((subsubmenu) => { subsubmenu.classList.remove('active'); });
    document.body.classList.remove('overlay');
  }

  $('.hero-swiper .swiper-slide').addClass('active');

  subMenuActivators.forEach(activator => {
    activator.addEventListener("mouseover", (e) => {
      subMenuActivators.forEach(innerActivator => { innerActivator.classList.remove('is-active')});
      activator.classList.add('is-active');
      let dropBodyToOpen = activator.dataset.bodyFor;
      dropBodies.forEach(dropBody => {
        if(dropBody.dataset.bodyFor === dropBodyToOpen) {
          dropBody.classList.add('is-active');
        } else {
          dropBody.classList.remove('is-active');
        }
      });
      dropMenu.classList.add("active-menu");
      document.body.classList.add("overlay");
    });
  });

  subMenuDeactivators.forEach(deactivator => {
    deactivator.addEventListener("mouseover", (e) => {
      subMenuActivators.forEach(innerActivator => { innerActivator.classList.remove('is-active')});
      dropBodies.forEach(dropBody => {
        dropBody.classList.remove("is-active");
      });
      dropMenu.classList.remove("active-menu");
      document.body.classList.remove("overlay");
      closeMobileMenu();
    });
  });

  let headerSection = document.querySelector('#shopify-section-header');

  headerSection.addEventListener("mouseleave", function (e) {
    dropMenu.classList.remove("active-menu");
    document.body.classList.remove("overlay");
    menuBody.classList.remove("active");
    closeMobileMenu();
  });
  
  document.addEventListener("scroll", function (e) {
    dropMenu.classList.remove("active-menu");
    document.body.classList.remove("overlay");
    menuBody.classList.remove("active");
    closeMobileMenu();
  });

  document.addEventListener("scroll", function (e) {
    document.querySelector('#predictive-search').style.display = 'none';
  });



  AOS.init({
    once: true
  });

  //Mailchimp
  $('.subscribe-modal').click(() => {
    $('#subscribe-modal').addClass('active');
  })
  $('.subscribe-modal-close').click(() => {
    $('#subscribe-modal').removeClass('active');
  })

  //Klaviyo
  // document.querySelector('.klaviyo_form_trigger').addEventListener('click', function () {
  //   window._klOnsite = window._klOnsite || [];
  //   window._klOnsite.push(['openForm', 'Ryd7DF']);
  // });

  $(window).scroll(function () {
    var sticky = $('.header__wrapper'),
      scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass('active');
    else sticky.removeClass('active');
  });

  $('.rc_layout .columns a').attr("href", "/account/");
});

// shop page
$(document).ready(function () {


  $('.shop__variants .shv_active').each(function () {
    var seletecOption = $(this).text();
    $(this).parent().prev().text(seletecOption)
  })
  $(document).on('click', '.shop__variants span', function () {
    $(this).parents('.shop__variants').find('span').not(this).removeClass('shv_active');
    $(this).addClass('shv_active');

    var seletecOption = $(this).text();
    var activeOption = $(this)
    $(this).parent().prev().text(seletecOption)
    if ($(window).width() < 768 && activeOption.closest('.shop_vmain').find('.selected-option').length > 0) {
      activeOption.parent().slideToggle()
    }
    var link = $(this).data('link');
    $(this).parents('.shop__item').find('.shop__item-button').attr('href', link);
    var parentwrapper = $(this).closest('.shop__item')
    var sprice = $(this).data('sprice');
    var orignalprice = $(this).data('orignalprice');
    var bredeerDiscount = $(this).data('bredderprice')
    var compareprice = $(this).data('compareprice')
    $(this).parents('.shop__item').find('.orignalprice, .product-regular-price, .shop_psprice').text(orignalprice)
    $(this).parents('.shop__item').find('.shop_subprice').text(sprice)
    $(this).parents('.shop__item').find('.breeder-price').text(bredeerDiscount);
    // $(this).parents('.shop__item').find('.compareprice').text(compareprice);
    var variantID = $(this).data('id')
    var wcp_json = $(this).closest('.shop__item').find('.wcp_json')
    var WCP_JSON = [];
    if (wcp_json.length) {
      WCP_JSON = JSON.parse(wcp_json[0].innerText);
      $.each(WCP_JSON.variants, function (index, value) {
        if (variantID == value.id) {
          parentwrapper.find('.shop_psprice').text(Shopify.formatMoney(value.price))
          parentwrapper.find('.orignalprice').text(Shopify.formatMoney(value.price))

          if (value.compare_at_price != null) {
            parentwrapper.find('.compareprice').text(' was ' + Shopify.formatMoney(value.compare_at_price));
            parentwrapper.find('.compareprice').show()
          } else if (value.compare_at_price == null) {
            parentwrapper.find('.compareprice').hide()
          }
          return false;
        }
      });
    }

    // Set variant ID on form
    const card = $(this).closest('[data-thumbnail]');
    const cardVariantInput = card.find('[data-thumbnail-variant]');
    cardVariantInput.val(variantID);
  })
});
$(document).on('click', '.selected-option', function () {
  $(this).next().slideToggle()
})